"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SUGGEST_A_DAY_MODALS = exports.WARNING_NUDGE_MODAL = void 0;
exports.WARNING_NUDGE_MODAL = {
    HEADER: 'This may be risky',
    BODY: "After this payment, you will only have a few days to make your payment for {{upcomingMonth}}'s rent.\n\nIf you do not pay off your balance by the last day of the month, your credit line will be suspended.",
    LINK_BUTTON: 'Back',
    CTA: 'Confirm'
};
var SUGGEST_DAY_MODAL_DEFAULT = {
    HEADER: 'Schedule for {{suggestedDateLong}} instead?',
    LINK_BUTTON: 'Keep {{originalDateShort}}',
    CTA: 'Change to {{suggestedDateShort}}'
};
exports.SUGGEST_A_DAY_MODALS = {
    WEEKEND: __assign(__assign({}, SUGGEST_DAY_MODAL_DEFAULT), { BODY: "We don't recommend scheduling payments on a weekend. Your bank may delay transactions until the next business day, which puts you at risk of missing your payment." }),
    END_OF_MONTH_WEEKEND: __assign(__assign({}, SUGGEST_DAY_MODAL_DEFAULT), { BODY: "We don't recommend scheduling payments on a weekend. Your bank may delay transactions until the next business day, which puts you at risk of missing the payment deadline and losing access to Flex." }),
    END_OF_MONTH_WEEKDAY_A: __assign(__assign({}, SUGGEST_DAY_MODAL_DEFAULT), { BODY: 'Friday is our most popular payment day of the month because it aligns with paychecks. If this day works for you, pay on {{suggestedDateTiny}} to give yourself more time to prepare for {{currentMonth}} rent!' }),
    END_OF_MONTH_WEEKDAY_B: __assign(__assign({}, SUGGEST_DAY_MODAL_DEFAULT), { BODY: '{{currentMonth}} rent is due just 1 day after {{lastDayInMonth}}! Move your payment to {{suggestedDateTiny}} for more breathing room.' })
};
